import { useCallback } from "react";
import { ViewStyle } from "react-native";
import { SpotlightPagination } from "./types";
import useSpotlightCardWidth from "./useSpotlightCardWidth";
import useSpotlightNavigation from "./useSpotlightNavigation";

type Params = {
  pagination: SpotlightPagination;
  visible: boolean;
  width: ViewStyle["width"];
  onClose?: () => void;
};

export default function useSpotlightCarousel({
  pagination,
  visible,
  width,
  onClose,
}: Params) {
  const {
    flatListRef,
    total,
    currentIndex,
    isFirst,
    isLast,
    isCarousel,
    activeItem,
    onForward,
    onBack,
  } = useSpotlightNavigation({ pagination, visible, onClose });
  const { itemWidth, onMeasureWidth } = useSpotlightCardWidth({ width });

  const cardButtonLabel = activeItem?.buttonLabel;

  const handleSoftDismiss = useCallback(() => {
    pagination.onSoftDismiss?.();
    onClose?.();
  }, [pagination, onClose]);

  return {
    isCarousel,
    activeItem,
    cardButtonLabel,
    handleSoftDismiss,
    carouselProps: {
      flatListRef,
      total,
      currentIndex,
      isFirst,
      isLast,
      cardButtonLabel,
      itemWidth,
      onMeasureWidth,
      onForward,
      onBack,
    },
  };
}
